export default {
  margin: {
    top: '3.75rem',
  },
  padding: {
    top: '1.125rem',
  },
  link: {
    padding: {
      right: '0.625rem',
    },
  },
  links: {
    padding: {
      vertical: '0.625rem',
      horizontal: '0',
    },
    border: {
      bottom: {
        style: 'solid',
        thickness: '0.03125rem',
      },
      top: {
        style: 'solid',
        thickness: '0.03125rem',
      },
    },
  },
};
